import React from 'react';
import { motion } from 'framer-motion';
import { Button, JaliPattern } from './ui/Shared';
import { PhulkariBorder } from './ui/Ornaments';
import { useApply } from './ApplyContext';
export const ApplySection = () => {
  const {
    open
  } = useApply();
  return <section id="apply" className="py-32 bg-navy relative overflow-hidden" data-id="element-33">
      <div className="absolute inset-0 bg-noise pointer-events-none z-10" data-id="element-34" />
      <JaliPattern className="absolute inset-0 text-gold opacity-10" data-id="element-35" />

      <div className="absolute top-0 left-0 w-full h-2 text-kesari/30 z-20" data-id="element-36">
        <PhulkariBorder className="w-full h-full" data-id="element-37" />
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-20 text-center" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-39">
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="font-gurmukhi text-kesari text-2xl md:text-3xl mb-6 tracking-widest opacity-90" data-id="element-40">
            ਚੜ੍ਹਦੀ ਕਲਾ
          </motion.div>

          <h2 className="font-serif text-5xl md:text-7xl text-ivory mb-6 tracking-tight" data-id="element-41">
            Applications close <br data-id="element-42" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-kesari" data-id="element-43">
              August 15, 2026.
            </span>
          </h2>
          <p className="font-sans text-xl text-parchment/80 mb-4" data-id="element-44">
            Inaugural pilot cohort — 25 participants. Module dates to be
            confirmed.
          </p>
          <p className="font-sans text-sm text-kesari-soft/90 mb-12 tracking-wide" data-id="element-45">
            Selected applicants will be informed by August 31, 2026.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-16" data-id="element-46">
            <Step num="1" text="Apply Online" delay={0.2} data-id="element-47" />
            <motion.div initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} className="hidden md:block w-12 h-px bg-kesari/50 origin-left" data-id="element-48" />
            <Step num="2" text="Virtual Interview" delay={0.4} data-id="element-49" />
            <motion.div initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.6
          }} className="hidden md:block w-12 h-px bg-kesari/50 origin-left" data-id="element-50" />
            <Step num="3" text="Offer Extended" delay={0.6} data-id="element-51" />
          </div>

          <motion.div whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-52">
            <Button onClick={open} variant="solid" className="text-lg px-10 py-4 shadow-[0_0_30px_rgba(212,118,60,0.3)]" data-id="element-53">
              Start Application
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
};
const Step = ({
  num,
  text,
  delay
}: {
  num: string;
  text: string;
  delay: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true
}} transition={{
  delay
}} className="flex flex-col items-center gap-3 group" data-id="element-54">
    <div className="w-10 h-10 rounded-full border border-gold text-gold group-hover:border-kesari group-hover:text-kesari group-hover:bg-kesari/10 transition-all flex items-center justify-center font-serif text-lg relative overflow-hidden" data-id="element-55">
      <span className="relative z-10" data-id="element-56">{num}</span>
    </div>
    <span className="font-sans text-sm text-ivory group-hover:text-kesari-soft transition-colors" data-id="element-57">
      {text}
    </span>
  </motion.div>;